<template>
    <div class="app-body">
        <div class="a-flex-rsbc a-ptb-6">
            <span class="a-fs-16 a-fw-700">设备图片拍摄</span>
            <div class="a-flex-rfsc">
                <el-button icon="el-icon-upload2" @click="exportfile(2)" v-if="selectData.length">批量导出</el-button>
                <el-button icon="el-icon-upload2" @click="exportfile(1)">全部导出</el-button>
            </div>
        </div>
        <el-card class="el-main" ref="pageCard">
            <le-search-form @reset="handlerRest" @search="handlerSearch" :canPackUp="true" id="leSearch">
                <le-input label="设备号" v-model="pageParam.params.deviceCode" />
                <le-select-remote-search label="设备种类" v-model="pageParam.params.deviceCategory" :options="optionsDeviceCategroy" placeholder="请选择" />
                <le-select-remote-search label="设备类型" v-model="pageParam.params.deviceType" :options="optionsDeviceType" placeholder="请选择" />
                <!-- <le-input label="站点名称" v-model="pageParam.params.stationName" /> -->
                <le-select-remote-search label="所属站点" v-model="pageParam.params.stationId" :options="optionsStation" placeholder="请选择（可输入搜索）" />
                <le-company-under-select label="加盟商" v-model="pageParam.params.companyId"></le-company-under-select>
                <le-select-local-search label="导出状态" v-model="pageParam.params.exportStatus" :options="exportStatusDic" />
                <le-date-range label="上传时间"  :minDate.sync="pageParam.params.uploadStartTime" :maxDate.sync="pageParam.params.uploadEndTime" />
            </le-search-form>
            
            <le-pagview ref="deviceListPage" @setData="setTableData" :pageParam="pageParam" :isFixed="true" :tableRef="$refs.deviceList">
                <el-table 
                    class="isHiddenScroll"
                    ref="deviceList" 
                    :data="tableData" 
                    :row-key="getRowKey"
                    @selection-change="handleSelectionChange"
                    @select="selectItem"
                    @select-all="selectAll"
                    :highlight-current-row="true" 
                    v-sticky="{ top: 0, parent:'.el-card__body' }"
                    style="width: 100%">
                    <el-table-column type="selection" fixed="left" align="center" width="55" reserve-selection  class="device-checkBox"></el-table-column>
                    <el-table-column prop="deviceCode" label="设备号" min-width="120">
                        <template slot-scope="{ row }">
                            <span class="a-c-blue font-point" @click="getDeviceDetails(row)">{{ row.deviceCode?row.deviceCode:'-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deviceCategoryName" label="设备种类" min-width="120"></el-table-column>
                    <el-table-column prop="deviceTypeName" label="设备类型" min-width="120"></el-table-column>
                    <el-table-column prop="stationName" label="所属站点" min-width="240">
                        <template slot-scope="{ row }">
                            <span>{{ row.stationName?row.stationName:'-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="companyName" label="所属加盟商" min-width="200">
                        <template slot-scope="{ row }">
                            <span>{{ row.companyName?row.companyName:'-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="lastUploadTime" label="最近上传时间" min-width="160">
                        <template slot-scope="{ row }">
                            <span>{{ row.lastUploadTime?row.lastUploadTime:'-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="lastExportTime" label="最近导出时间" min-width="160">
                        <template slot-scope="{ row }">
                            <span>{{ row.lastExportTime?row.lastExportTime:'-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="companyName" label="导出状态" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.exportStatus | initDic(exportStatusDic) }}</span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="name" label="操作" min-width="112" fixed="right" >
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" content="详情" placement="top">
                                <img src="../../assets/icon/option-detail.png" class="a-wh-16" @click="getDeviceInfo(scope.row)" />
                            </el-tooltip>
                            <el-tooltip class="item a-ml-12" effect="dark" content="导出" placement="top">
                                <img @click="exportfile(0, scope.row)" src="../../assets/icon/option-export.png" class="a-wh-16" />
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </le-pagview>
        </el-card>
    </div>
</template>

<script>
import util from "../../utils/util.js";
export default {
    components:{
    },
    data() {
        return {
            util,
            tableData: [],
            selectData: [],//选中的列表
            pageParam: {
                url: this.$Config.apiUrl.uploadDevicePage,
                method: "post",
                params: {
                    companyId: "",// 加盟商
                    deviceCategory: '',// 种类筛选
                    deviceCode: '',// 设备码 
                    deviceType: "",
                    exportStatus: "",
                    stationId: '',
                    uploadEndTime: '',
                    uploadStartTime: ''
                },
                freshCtrl: 1,
            },
            optionsDeviceType: {
                url: this.$Config.apiUrl.getDeviceType,
                method: "post",
                params: {
                    deviceCategroy: ''
                },
                showLoading: false,
                labelKey: "name",
                valueKey: "id",
                searchKey: "key",
            },
            optionsDeviceCategroy: {
                url: this.$Config.apiUrl.getDeviceCategroyList,
                method: "post",
                params: {},
                showLoading: false,
                labelKey: "deviceCategroy",
                valueKey: "id",
                searchKey: "key",
            },
            optionsStation: {
                url: this.$Config.apiUrl.getStationList,
                method: "post",
                params: {},
                showLoading: false,
                labelKey: "name",
                valueKey: "stationId",
                searchKey: "name",
                pageSize: 100
            },//站点数据
            exportStatusDic: []
        };
    },
    watch:{
        "pageParam.params.deviceCategory":{
            deep: true,
            immediate: true,
            handler (newVal, oldVal) {
                if(newVal != oldVal){ // 选择设备种类
                    this.pageParam.params.deviceType = ''
                    this.optionsDeviceType.params.deviceCategroy = newVal
                }
            }
        }
    },
    created () {
        this.$getDic('antChainExportStatus','select').then(res=>{ this.exportStatusDic = res; })
    },
    methods: {
        //获取设备列表
        setTableData(data) {
            this.tableData = data;
        },
        handlerRest() {
            this.pageParam.params = {
                deviceCode: '',// 设备码 
                stationName: '',
                companyId: "",// 加盟商
                installStartTime: "",
                installEndTime: "",
                deviceType: "",
                status: "", //设备状态
                canUse: '',//启用状态
                csqCode: '',
                deviceCategory: '',
                canRfid: '',
                canFace: '',
                imei: '',
                mark: ''
            };
            this.$refs['deviceList'].clearSelection()
            this.handlerSearch()
        },
        handlerSearch() {
            this.$refs['deviceListPage'].pageNum = 1
            this.pageParam.freshCtrl++;
        },
        getRowKey (row) {
            return row.deviceCode
        },
        // 单选
        selectItem(list, row) {
            // this.selectData = list
            // this.selectData = Array.from(new Set(this.selectData))
        },
        // 全选
        selectAll(selection) {
            // this.selectData = selection
            // this.selectData = Array.from(new Set(this.selectData))
        },
        handleSelectionChange (selection) {
            this.selectData = selection
        },
        handleDeleteSelectDev (datas) {
            this.selectData.splice(this.selectData.indexOf(datas), 1);
            this.$refs['deviceList'].toggleRowSelection(datas)
        },
        getDeviceInfo (datas) {
            this.$router.push({
                path: '/device/device-imgcheck-info',
                query:{
                    deviceCode: datas.deviceCode,
                    id: datas.id
                }
            })
        },
        getDeviceDetails (datas) {
            this.$router.push({
                path: '/device/device-info',
                query:{
                    deviceCode: datas.deviceCode,
                }
            })
        },
        exportfile (type, datas) {
            let fileName = '', exportIdList = []
            if(type == 1 || type == 2) {
                // 筛选条件全部导出
                fileName = '设备图片拍摄'
                if(type == 2) {
                    exportIdList = this.selectData.map(item=>{
                        return item.id
                    })
                }
            }else {
                fileName = '设备图片拍摄-' + (datas.deviceCode + '（上传时间：' + datas.lastUploadTime + '）')
                exportIdList = [datas.id]
            }
            this.$exfile({
                code: 30,
                fileName: fileName,
                params: {
                    ...this.pageParam.params,
                    exportIdList: exportIdList,
                    totalExport: type == 1 ? 1 : ''
                }
            })
        },
    },
}
</script>

<style lang="scss" scoped>
    .device-off{
        width: 6px;
        height: 6px;
        background: #909499;
        border-radius: 50%;
        margin-right: 6px;
    }
    .device-online{
        width: 6px;
        height: 6px;
        background: #29CC29;
        border-radius: 50%;
        margin-right: 6px;
    }
    .slotUseStatus{
        width: 48px;
        height: 24px;
        min-height: 24px !important;
        background: #F4F6F9;
        // margin-bottom: 8px;
        display: inline-block;
        span{
            display: block;
            width: 48px;
            height: 24px;
            text-align: center;
            line-height: 24px;
            // margin-top: 4px;
        }
        .grayBorder{
            border-right: 1px solid #E3E3E3;
        }
        .slotUsing{
            color: #29CC29;
        }
        .slotNotUse{
            color: #909499;
        }
    }
    .c29CC29{
        color: #29CC29;
    }
    .cFFA900{
        color: #FFA900
    }
    .cFF3B30{
        color: #FF3B30
    }
    .width280{
        width: 280px;
    }
    .progress{
        width: 205px;
        height: 7px;
        border-radius: 4px;
        margin: 13px 0 24px;
        background: #B9B9B9
    }
    .progress-item{
        width: 100%;
        height: 7px;
        border-radius: 4px;
        background: #007AFF;
        animation: progressPop 10s;
        -webkit-animation: progressPop 5s; /* Safari and Chrome */
    }
    /* 动画 */
    @keyframes progressPop
    {
        from {width: 0;}
        to {width:100%;}
    }

    @-webkit-keyframes progressPop /* Safari and Chrome */
    {
        from {width: 0;}
        to {width:100%;}
    }
    .s-btn-exp{
        margin: 0 14px
    }
    .mb8{
        margin-bottom: 8px
    }
    .online-dev{
        width: 7px;
        height: 7px;
        min-height: 7px !important;
        border-radius: 50%;
        background: #32CF4C
    }
    .offline-dev{
        width: 7px;
        height: 7px;
        min-height: 7px !important;
        border-radius: 50%;
        background: #B9B9B9
    }
    .damage-dev{
        width: 7px;
        height: 7px;
        min-height: 7px !important;
        border-radius: 50%;
        background: #FF3B30
    }

    /deep/ .el-table-column--selection .cell {
        justify-content: center !important;
    }

    // 复选记录框
    .checkedDevList{
        width: 100%;
        overflow-y: auto;
        padding: 0 0 8px 0;
    }
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
        /*width: 0;宽度为0隐藏*/
        // width: 0 !important;
        height: 0 !important;
    }
    /deep/ .el-table__fixed, /deep/ .el-table__fixed-right{
       height: 100% !important;
    }
</style>
